var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimesCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8 15.9297C12.1421 15.9297 15.5 12.5718 15.5 8.42969C15.5 4.28755 12.1421 0.929688 8 0.929688C3.85786 0.929688 0.5 4.28755 0.5 8.42969C0.5 12.5718 3.85786 15.9297 8 15.9297Z",
    fill: "#EC4040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79416 8.42982L10.6459 6.57732C10.7453 6.47069 10.7994 6.32965 10.7968 6.18393C10.7942 6.0382 10.7352 5.89916 10.6321 5.7961C10.5291 5.69304 10.39 5.63401 10.2443 5.63144C10.0986 5.62886 9.95754 5.68296 9.85091 5.78232L7.99841 7.63407L6.14591 5.78232C6.03928 5.68296 5.89824 5.62886 5.75251 5.63144C5.60679 5.63401 5.46775 5.69304 5.36469 5.7961C5.26163 5.89916 5.2026 6.0382 5.20002 6.18393C5.19745 6.32965 5.25155 6.47069 5.35091 6.57732L7.20266 8.42982L5.35091 10.2823C5.29564 10.3338 5.25131 10.3959 5.22057 10.4649C5.18983 10.5339 5.1733 10.6084 5.17196 10.6839C5.17063 10.7595 5.18452 10.8345 5.21281 10.9045C5.24111 10.9746 5.28321 11.0382 5.33663 11.0916C5.39004 11.145 5.45367 11.1871 5.52371 11.2154C5.59375 11.2437 5.66877 11.2576 5.7443 11.2563C5.81983 11.2549 5.89431 11.2384 5.96331 11.2077C6.03231 11.1769 6.09441 11.1326 6.14591 11.0773L7.99841 9.22557L9.85091 11.0773C9.95754 11.1767 10.0986 11.2308 10.2443 11.2282C10.39 11.2256 10.5291 11.1666 10.6321 11.0635C10.7352 10.9605 10.7942 10.8214 10.7968 10.6757C10.7994 10.53 10.7453 10.3889 10.6459 10.2823L8.79416 8.42982Z",
    fill: "#EC4040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesCircle);
export default __webpack_public_path__ + "static/media/times-circle.8ba4c45bf1839721d6bf5fdf5ef6adc8.svg";
export { ForwardRef as ReactComponent };